import { WithIconTextareaFormInput } from "../generic/forms/withIconTextAreaFormInput";
import { SvgEnvelop } from "../../assets/icons";

export const EmailEditForm = () => {
  return (
    <WithIconTextareaFormInput
      className="p-0 w-100"
      name="domainName"
      svgicon={SvgEnvelop}
    />
  );
};
